import { useEffect, useRef, useState } from 'react';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import { retrieveAncmntDtl } from '../../api/FnSmartTBM';
import axios from "axios";
import { useDidMountEffect } from '../../hook/useDidMountEffect';

export default function SmrtTBMAncmnt({ doneTBM, agrd, setAgrd, ancmntData, setAncmntData, fileDataList, setFileDataList, setReadAncmntList, readAncmntList, sctrGb }: any) {
  const [ancmnt, setAncmnt] = useState<any>();
  const [backArrowState, setBackArrowState] = useState(false);
  const [forwardArrowState, setForwardArrowState] = useState(true);
  const inputRef = useRef<any>();
  const inputClick = () => { inputRef.current.click(); };

  useEffect(() => {
    retrieveAncmntDtl({ sctrGb, setAncmntData, setAncmnt, setReadAncmntList, readAncmntList, setFileDataList });
  }, [])
  useDidMountEffect(() => {
    if (Array.isArray(ancmntData) && ancmntData.length === 0) { setAgrd((prevState: any) => ({ ...prevState, 2: true })) }
    else if (ancmntData && ancmntData.length === 1) { setForwardArrowState(false); }
  }, [ancmntData])

  const arrowHandler = (dir: string) => {
    let index = ancmntData?.findIndex((i: any) => i.seq === ancmnt?.seq);
    if (index !== 0 && dir === 'back') {
      setAncmnt({ seq: ancmntData[index - 1].seq, title: ancmntData[index - 1].title, cntnts: ancmntData[index - 1].cntnts, atchFileId: ancmntData[index - 1].atchFileId })
    } else if (index !== ancmntData.length - 1 && dir === 'forward') {
      setAncmnt({ seq: ancmntData[index + 1].seq, title: ancmntData[index + 1].title, cntnts: ancmntData[index + 1].cntnts, atchFileId: ancmntData[index + 1].atchFileId })
    }
    if (dir === 'back') {
      if (index - 1 === 0) { setBackArrowState(false); setForwardArrowState(true); }
      else if (index - 1 !== 0 && index - 1 !== ancmntData.length - 1) { setBackArrowState(true); setForwardArrowState(true); }
    } else if (dir === 'forward') {
      if (index + 1 !== 0 && index + 1 !== ancmntData.length - 1) { setBackArrowState(true); setForwardArrowState(true); }
      else if (index + 1 === ancmntData.length - 1) { setBackArrowState(true); setForwardArrowState(false); }
    }
  };

  useEffect(() => {
    setReadAncmntList(readAncmntList.concat(ancmnt?.seq))
    if (ancmnt) {
      fn_retrieveFilDataList(ancmnt.atchFileId)
    }
  }, [ancmnt])

  const fn_retrieveFilDataList = async (atchFileId: any) => {
    const rtrnData = await axios.post('admin/api/cmmn/fileInfoForTableView', { atchFileId: atchFileId });
    setFileDataList(rtrnData.data.fileList);
  }

  return (
    <div className='flex flex-col justify-center items-center w-[260px] sm:w-[318px] md:w-[750px]'>
      {ancmntData?.length === 0 ? <p className='w-[90%] mt-32 text-15 leading-18 md:mt-[80px] md:text-37 md:leading-45 font-preBold'>등록된 공지사항이 없습니다.</p>
        : <>
          <p className='w-[90%] mt-32 text-15 leading-18 md:mt-[80px] md:text-37 md:leading-45 font-preBold'>제목<span className='ml-24 md:ml-[60px] font-preLight'>{ancmnt?.title}</span></p>
          <p className='w-[90%] mt-16 text-15 leading-18 md:mt-[40px] md:text-37 md:leading-45 font-preBold mb-17 md:mb-[42px]'>내용</p>
          <div className='w-[100%] flex justify-between items-center'>

            {ancmntData?.length === 1 ? <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
              : backArrowState ? <IoIosArrowBack className='text-30 md:text-75 text-[#C3C3C3]' onClick={() => arrowHandler('back')} /> : <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>}

            <div className='w-[90%] flex flex-col justify-center md:text-37'>
              <p className='w-full flex justify-center whitespace-pre-line'>{ancmnt?.cntnts}</p>
              {
                fileDataList?.map((fileData: any) => (
                  <img key={fileData.fileSn} alt='file' src={`admin/api/cmmn/fileDownload?atchFileId=${fileData.atchFileId}&fileSn=${fileData.fileSn}`} className='object-cover' />
                ))
              }
            </div>

            {ancmntData?.length === 1 ? <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
              : forwardArrowState ? <IoIosArrowForward className='text-30 md:text-75 text-[#C3C3C3]' onClick={() => arrowHandler('forward')} /> : <div className='text-30 md:text-75'>&nbsp;&nbsp;&nbsp;&nbsp;</div>}

          </div>
          {/*{!doneTBM && <div className='flex w-full mt-25 md:mt-[62px]'>*/}
          {/*  {!agrd[2] ? <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 2: !agrd[2] }))} type='checkbox' className='accent-point md:w-[40px]' />*/}
          {/*    : <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 2: !agrd[2] }))} type='checkbox' className='accent-point md:w-[40px]' defaultChecked />}*/}
          {/*  <p onClick={inputClick} className='ml-10 md:ml-[25px] text-[#9C9C9B] text-13 leading-15 md:text-32 md:leading-37 font-preLight underline underline-offset-1 decoration-[#9C9C9B] decoration-[0.5px]'>모든 공지사항을 확인하고, 숙지하였습니다.</p>*/}
          {/*</div>}*/}
        </>
      }
    </div>
  );
}
